import { Grid } from "@material-ui/core";
import { getValueToIconMapForHazard } from "../map/HazardSelectorHelper";
import { getValueToIconMapForKPI } from "../map/KPISelectorHelper";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../util/tableUtils";

const garanziasBase =
  // This is the list of garanzias that are related to each hazard.
  // Used as helper, it has no effect on the map and tables.
  // It should be in sync with harazdlist column which was createed in
  // C:\dev\cys-realerisk-sftp-py-service\notebooks\realerisk_mongodb_dbclimate_analyticssplit.ipynb,
  // see cells that mention version v2,v3.
  // The code below is printed to legend.js

  // OLD:
  // For version v1 (the first version with colored boxes)
  // It is created in file
  // cys-realerisk-analytics-datavalidation\notebooks\garanzia-perils-short-report_v1.json
  // when you rerun cys-realerisk-analytics-datavalidation\notebooks\11_hazard_peril_reader_v1.ipynb

  {
    anyhazard: ["Fre venti forti", "Fre grandine", "Fre eccesso di neve", "Fre eccesso di pioggia"],
    wind: ["Fre venti forti"],
    hail: ["Fre grandine"],
    snow: ["Fre eccesso di neve"],
    rain: ["Fre eccesso di pioggia"],
    lightning: [""],
  };

const garanziasBase2 = {
  ...garanziasBase,
  landslide: [],
};

const garanzias = {
  ...garanziasBase2,
  aniaWindstorm: garanziasBase.wind,
  aniaLightning: garanziasBase.lightning,
  aniaPrecipitation: garanziasBase.rain, // meaning rain / pioggia
  aniaHail: garanziasBase.hail,
  aniaSnow: garanziasBase.snow,

  cysNcat: [
    ...new Set(garanziasBase.wind.concat(garanziasBase.hail, garanziasBase.rain, garanziasBase.snow)),
  ],
  aniaNcat: [
    ...new Set(garanziasBase.wind.concat(garanziasBase.hail, garanziasBase.rain, garanziasBase.snow)),
  ],

  cysNat: [...new Set(garanziasBase.wind.concat(garanziasBase.hail))],
  aniaNat: [...new Set(garanziasBase.wind.concat(garanziasBase.hail))],
  weatherindex: [...new Set(garanziasBase.wind.concat(garanziasBase.hail))],
};

export const hazardGaranzias = (hazardSelect, KPISelect) => {
  let retHazardGaranzias = "";

  if (hazardSelect !== "none") {
    if (!garanzias[hazardSelect]) {
      console.error(`hazardSelect ${hazardSelect} not found in garanzias `, garanzias);
    }
    retHazardGaranzias = JSON.stringify(
      garanzias[hazardSelect]
        .map((garanzia) => capitalizeFirstLetter(garanzia))

        .sort(),
    ).replace(/,/g, ", ");
  }
  return retHazardGaranzias;
};

export const AgroBivariateLegend = ({ hazardSelect, KPISelect, wantedReferenceDateProp }) => {
  const { t } = useTranslation();

  let explain = "";
  let hazardDetail = "";
  let hazardLevels = "";
  let KPIDetail = "";
  let KPILevels = "";

  const lowMediumHigh = `${t("analyticsLegend.white")} = ${t("levels.low")},  ${t(
    "analyticsLegend.pink",
  )} = ${t("levels.medium")},  ${t("analyticsLegend.red")} =  ${t("levels.high")}`;

  if (hazardSelect === "earthquake") {
    hazardDetail = t("riskExposureMapExplained.seismicClassification");
    hazardLevels = `${t("analyticsLegend.white")} =${t("analyticsLegend.zone")}  4,  pink=${t(
      "analyticsLegend.zone",
    )}  3,  ${t("analyticsLegend.red")} =${t("analyticsLegend.zone")}  1 and ${t("analyticsLegend.zone")}  2`;
  }

  if (hazardSelect === "hail") {
    hazardDetail = t("riskExposureMapExplained.hailItaLarge", {
      size: t("riskExposureMapExplained.large"),
      mm: 20,
      scenario: "",
    });
    hazardLevels = `${t("analyticsLegend.white")} : <= 0.019,  ${t(
      "analyticsLegend.pink",
    )} : 0.020-0.039,  ${t("analyticsLegend.red")} : >= 0.040 ${t("analyticsLegend.probabilityFraction")} `;
  }

  if (hazardSelect === "snow") {
    hazardDetail = t("riskExposureMapExplained.snowIta", { cm: 5 });
    hazardLevels = `${t("analyticsLegend.white")} : <20,  ${t("analyticsLegend.pink")} : 20-70,  ${t(
      "analyticsLegend.red",
    )} : >70  ${t("analyticsLegend.probabilityPercents")}`;
  }

  if (hazardSelect === "lightning") {
    hazardDetail = t("riskExposureMapExplained.lightningStrike");
    hazardLevels = `${t("analyticsLegend.white")} : <8.5,  ${t("analyticsLegend.pink")} : 8.5-17,  ${t(
      "analyticsLegend.red",
    )} : >17 events/km2/year`;
  }

  if (hazardSelect === "wind") {
    hazardDetail = t("riskExposureMapExplained.windSevere");
    hazardLevels = `${t("analyticsLegend.white")} <=0.36,  ${t("analyticsLegend.pink")} :0.37-0.85,  ${t(
      "analyticsLegend.red",
    )} : >=0.86 ${t("analyticsLegend.probabilityFraction")} `;
  }

  if (hazardSelect === "rain") {
    hazardDetail = t("riskExposureMapExplained.flashFloodIta", { hour: 24 });

    hazardLevels = `${t("analyticsLegend.white")} : <=3.06,  ${t("analyticsLegend.pink")} : 3.07-4.84,  ${t(
      "analyticsLegend.red",
    )} : >=4.85 mm/hour`;
  }

  if (hazardSelect === "weatherindex") {
    hazardDetail = t("analyticsLegend.weatherIndex");

    hazardLevels = `${t("analyticsLegend.white")} <0.5,  ${t("analyticsLegend.pink")} =0.5-1.5,  ${t(
      "analyticsLegend.red",
    )} >1.5`;
  }

  if (hazardSelect === "aniaWindstorm") {
    hazardDetail = t("aniaTooltip.windHazard") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaLightning") {
    hazardDetail = t("aniaTooltip.lightningStrike") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaPrecipitation") {
    hazardDetail = t("aniaTooltip.precipitation") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaHail") {
    hazardDetail = t("aniaTooltip.hail") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaSnow") {
    hazardDetail = t("aniaTooltip.precipitationSnow") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaNcat") {
    hazardDetail = t("climateIndex.AniaNcat") + t("climateIndex.AniaNcatLegend") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaNat") {
    hazardDetail = t("climateIndex.AniaNe") + t("climateIndex.AniaNeLegend") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "cysNcat") {
    hazardDetail = t("climateIndex.CysNcat") + t("climateIndex.CysNcatLegend");
    hazardLevels = `${t("analyticsLegend.white")} <33,  ${t("analyticsLegend.pink")} =33-66,  ${t(
      "analyticsLegend.red",
    )} >66`;
  }

  if (hazardSelect === "cysNat") {
    hazardDetail = t("climateIndex.CysNe") + t("climateIndex.CysNeLegend");
    hazardLevels = `${t("analyticsLegend.white")} <33,  ${t("analyticsLegend.pink")} =33-66,  ${t(
      "analyticsLegend.red",
    )} >66`;
  }

  if (KPISelect === "policyNumber") {
    KPIDetail = t("analyticsLegend.kpiPolicies");
    KPILevels = `${t("analyticsLegend.white")} =0-3,  ${t("analyticsLegend.blue")} =4-14,  ${t(
      "analyticsLegend.darkBlue",
    )} =15+`;
  }

  if (KPISelect === "accruedRisk") {
    KPIDetail = t("analyticsLegend.kpiRiskYears");

    KPILevels = `${t("analyticsLegend.white")} =0-29,  ${t("analyticsLegend.blue")} =30-199,  ${t(
      "analyticsLegend.darkBlue",
    )} =200+`;
  }

  if (KPISelect === "postrenewalValueFinal") {
    KPIDetail = t("analyticsLegend.kpiTIV");
    KPILevels = `${t("analyticsLegend.white")} =€ 0-40 K,  ${t("analyticsLegend.blue")} =€ 40-300 K,  ${t(
      "analyticsLegend.darkBlue",
    )} =€ 300+ K`;
  }

  if (KPISelect === "premiumNettoEur") {
    KPIDetail = t("analyticsLegend.kpiPremiumNettoEur");
    KPILevels = `${t("analyticsLegend.white")} =€ 0-2K,  ${t("analyticsLegend.blue")} =€ 2-15 K,  ${t(
      "analyticsLegend.darkBlue",
    )} =€ 15+ K`;
  }

  if (hazardSelect === "anyhazard" && KPISelect === "none") {
    explain = `${t("analyticsLegend.seeRiskYears")}`;
  }

  if (hazardSelect !== "anyhazard" && KPISelect === "none") {
    explain = `${t("analyticsLegend.seeRiskLevel")}`;
  }

  if (hazardSelect === "anyhazard" && KPISelect !== "none") {
    explain = `${t("analyticsLegend.seeAllHazards")}`;
  }

  if (hazardSelect !== "anyhazard" && KPISelect !== "none") {
    explain = `${t("analyticsLegend.seeBivariate")}`;
  }

  if (hazardSelect !== "anyhazard" || KPISelect !== "none") {
    explain += " " + t("analyticsLegend.mapAffected");
  }

  const variantProp = "AgroClimateAnalytics";
  return (
    <Grid item xs={12} sm={12}>
      <div style={{ height: 300, width: "100%" }}>
        <h1>Legend</h1>

        <ul>
          {" "}
          <li>
            {t("analyticsLegend.hazardIs")} <b>&apos;{getValueToIconMapForHazard(hazardSelect).text}&apos;</b>{" "}
            {t("analyticsLegend.andKpiIs")}{" "}
            <b>&apos;{getValueToIconMapForKPI(KPISelect, variantProp).text}&apos;</b>.
          </li>
          <li>{explain}</li>
          {hazardDetail !== "" && (
            <li>
              {t("analyticsLegend.hazardDetails")}: {hazardDetail}{" "}
            </li>
          )}
          {hazardLevels !== "" && (
            <li>
              {t("analyticsLegend.hazardLevels")}: {hazardLevels}
            </li>
          )}
          {KPIDetail !== "" && (
            <li>
              {t("analyticsLegend.kpiDetails")}: {KPIDetail}{" "}
            </li>
          )}
          {KPILevels !== "" && (
            <li>
              {t("analyticsLegend.kpiLevels")}: {KPILevels}
            </li>
          )}
          {hazardGaranzias(hazardSelect, KPISelect) !== "" && (
            <li>
              {t("analyticsLegend.coveragesAre")} {hazardGaranzias(hazardSelect, KPISelect)}
            </li>
          )}
          <li>{t("analyticsLegend.bivariateOnlyNonZero")}</li>
        </ul>
      </div>
    </Grid>
  );
};
